import React, {Component} from "react";
import {connect} from "react-redux";
import BoxSection from "../../Layout/components/BoxSection";
import moment from "moment";
import numeral from 'numeral'
import Input from '@mawesi-sas/mws_react_component_input'
import { aprobarDistribucion } from "../actions";
import { showModalConfirmAction } from "../../Layout/actions";

class Aprobacion extends Component {
	canUserApprove = (user) => {
		const {isSuOrAdmin, isEditable} = this.props
		return isEditable && (isSuOrAdmin || (this.props.user.get('id') === user.get('id')))
	}

	isApprovedOrCanceled = (aprobacion) => {
		return aprobacion.get('estado') !== 'EN ESPERA'
	}

	render() {
		return (
			<div
				style={{
					height: "100%",
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-between"
				}}>
				<div className="row" style={{height: "100%"}}>
					<div className="col-md-12" style={{height: "100%"}}>
						<div className="box-content" style={{flex: 1}}>
							{this.props.distribuciones.map(x => {
								const aprobacion = x.get("aprobacion");
								return (
									<BoxSection
										key={`bs[0][${x.get("id")}]`}
										title={`Solicitud de aprobación a ${aprobacion.getIn(
											"aprobador.name".split(".")
										)}`}>
										<div className="row">
											<div className="col-md-12">
												<h4>
													Solicitud de
													aprobación:&nbsp;
													{aprobacion.get("estado")}
													{aprobacion.get(
														"estado"
													) === "EN ESPERA" ? (
														""
													) : (
														<span>
															&nbsp;&bull;&nbsp;
															{moment(
																aprobacion.get(
																	"updated_at"
																)
															).format(
																"YYYY-MM-DD HH:mm"
															)}
														</span>
													)}
												</h4>
											</div>
										</div>
										<div className="row">
											<div className="col-md-12">
												<span>
													Solicitada por:&nbsp;
													<b>
														{this.props.solicitante.get(
															"name"
														)}
													</b>
												</span>
												&nbsp; &bull; &nbsp;
												<span>
													<a
														href={`mailto:${this.props.solicitante.get(
															"email"
														)}`}>
														{this.props.solicitante.get(
															"email"
														)}
													</a>
												</span>
											</div>
										</div>
										<div className="row">
											<div className="col-md-12">
												<b>Detalle:</b>
											</div>
										</div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <table className="table table-bordered table-condensed table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '50%' }}>Producto / Servicio</th>
                                                            <th style={{ width: '10%' }}>Total</th>
                                                            <th style={{ width: '40%' }}>Distribución</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.props.detalles.map(d => {
                                                                return (
                                                                    <tr key={ `tr1[${aprobacion.get('id')}][${d.get('id')}]` }>
                                                                        <td>{ d.get('tipo_servicio') }&nbsp; &bull; &nbsp; { d.get('tipo_producto') }</td>
                                                                        <td style={{ textAlign: 'right' }}>{ numeral(d.get('subtotal')).format('$0,0.00') }</td>
                                                                        <td style={{ padding: 0 }}>
                                                                            <table className="table table-bordered table-condensed">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>Cenco</th>
                                                                                        <th>Porcentaje</th>
                                                                                        <th>Valor</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {
                                                                                        <tr key={ `tr2[${x.get('id')}]` }>
                                                                                            <td><span title={ `${x.getIn('cenco.nombre'.split('.'))}` }>{ x.getIn('cenco.codigo'.split('.')) }</span></td>
                                                                                            <td style={{ textAlign: 'right' }}>{ numeral(x.get('porcentaje') / 100).format('0.00%') }</td>
                                                                                            <td style={{ textAlign: 'right' }}>{ numeral((x.get('porcentaje') / 100) * d.get('subtotal')).format('$0,0.00') }</td>
                                                                                        </tr>
                                                                                    }
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="control-label">Observaciones</label>
                                                    <Input
                                                        type='textarea'
                                                        reducer='solicitud'
                                                        path={`distribuciones.data.${x.get('id3n71f13r')}.aprobacion.observaciones`}
                                                        disabled={!this.canUserApprove(aprobacion.get('aprobador'))}
                                                    />
                                                </div>
                                            </div>
                                        </div>
										{
											(this.canUserApprove(aprobacion.get('aprobador')) && !this.isApprovedOrCanceled(aprobacion) &&
												<div className="row">
													<div className="col-md-12">
														<div style={{ textAlign: 'right', padding: '10px 0' }}>
															<span>
																<button 
																	className="btn btn-primary btn-sm btn-squared" 
																	onClick={e => this.props.showModalConfirmAction(true, 'Esta seguro que desea aprobar esta solicitud?', () => this.props.aprobarDistribucion(aprobacion, true))}>Aprobar</button>
															</span>
															<span style={{ marginLeft: '10px' }}>
																<button
																	className="btn btn-default btn-sm btn-squared"
																	onClick={e => this.props.showModalConfirmAction(true, 'Esta seguro que desea rechazar esta solicitud?', () => this.props.aprobarDistribucion(aprobacion, false))}>Rechazar</button>
															</span>
														</div>
													</div>
												</div>
											)
										}
									</BoxSection>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		distribuciones: state.solicitud
			.getIn("distribuciones.data".split("."))
			.valueSeq(),
        solicitante: state.solicitud.get("solicitante"),
        detalles: state.solicitud.getIn('detalles.data'.split('.')).valueSeq(),
        user: state.signin.get('user')
	};
}

const mapDispatchToProps = {
	aprobarDistribucion,
	showModalConfirmAction
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Aprobacion);
